export default function Nav() {
  return (
    <>
      <nav className="nav">
        <div className="container nav-inner">
          <a href="#top" className="nav-logo" aria-label="Mystar Engineering Group">
            <img src="assets/logo-en.png" alt="Mystar Engineering Group" />
          </a>
          <div className="nav-links">
            <a href="#business">Business</a>
            <a href="#federation">Federation</a>
            <a href="#growth">Growth</a>
            <a href="#leadership">Leadership</a>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 22 }}>
            <span className="nav-lang">
              <span className="on">EN</span>
              &nbsp;/&nbsp;
              <a
                href="https://www.mystargroup.jp/"
                target="_blank"
                rel="noreferrer"
                style={{ color: 'var(--gray-3)' }}
              >
                JP
              </a>
            </span>
            <a href="#contact" className="nav-cta">
              Contact <span className="arr">→</span>
            </a>
          </div>
        </div>
      </nav>
      <div className="brand-rule" />
    </>
  );
}
